import CategoryFilterInput from './CategoryFilterInput';

export const getEventCategoryFilterOperators = (translate) => {
  const t = translate || ((k, opts) => opts?._ || k);
  return [
    {
      label: t('filters.equals', { _: 'Equals' }),
      value: 'equals',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const id = String(filterItem.value);
        return (params) => String(params.row?.category ?? params.value ?? '') === id;
      },
      InputComponent: CategoryFilterInput,
    },
  ];
};

const eventCategoryFilterOperators = getEventCategoryFilterOperators((k, opts) => opts?._ || k);

export default eventCategoryFilterOperators;
